// extracted by mini-css-extract-plugin
module.exports = {"identity":"styles_identity__23rUm","field":"styles_field__3rDpp","input":"styles_input__3ROab","input--invalid":"styles_input--invalid__-lkwE","error":"styles_error__1fEX2"};